import { render, staticRenderFns } from "./ListVillagePage.vue?vue&type=template&id=584de5ae&"
import script from "./ListVillagePage.vue?vue&type=script&lang=js&"
export * from "./ListVillagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports